/** 落地页地址栏参数。routeTo 会丢掉 query，登录前先快照到 sessionStorage。 */
const ENTRY_QUERY_KEY = 'difi_entry_query';

let memory: Record<string, string> | null = null;

const parseSearch = (search: string): Record<string, string> => {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  if (!raw) return {};
  const params: Record<string, string> = {};
  try {
    new URLSearchParams(raw).forEach((value, key) => {
      if (!key || key in params) return;
      params[key] = value;
    });
  } catch {
    return {};
  }
  return params;
};

const persist = (params: Record<string, string>) => {
  try {
    sessionStorage.setItem(ENTRY_QUERY_KEY, JSON.stringify(params));
  } catch {
    /* ignore */
  }
};

const restore = (): Record<string, string> => {
  try {
    const raw = sessionStorage.getItem(ENTRY_QUERY_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    if (!parsed || typeof parsed !== 'object') return {};
    const params: Record<string, string> = {};
    Object.entries(parsed).forEach(([key, value]) => {
      if (!key || value == null) return;
      params[key] = String(value);
    });
    return params;
  } catch {
    return {};
  }
};

/** App 启动时调用：有 query 则覆盖；无 query 则沿用本 tab 已缓存的落地参数。 */
export const snapshotEntryQuery = () => {
  const fromUrl = parseSearch(window.location.search);
  if (Object.keys(fromUrl).length > 0) {
    memory = fromUrl;
    persist(fromUrl);
    return;
  }
  if (memory && Object.keys(memory).length > 0) return;
  memory = restore();
};

/** 落地页 query 的副本。登录字段应在其后展开，避免被地址栏同名参数覆盖。 */
export const getEntryQueryParams = (): Record<string, string> => {
  if (memory == null) snapshotEntryQuery();
  return { ...(memory || {}) };
};
